import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'

interface UnsavedChangesDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  message?: string
  title?: string
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  message = 'You have unsaved changes. Are you sure you want to leave?',
  title = 'Unsaved Changes',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
        },
      }}
    >
      <DialogTitle
        id="unsaved-changes-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pb: 1,
        }}
      >
        <WarningIcon color="warning" />
        {title}
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Typography
          id="unsaved-changes-dialog-description"
          variant="body1"
          color="text.secondary"
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 600,
            borderColor: '#000',
            color: '#000',
            '&:hover': {
              borderColor: '#000',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="outlined"
          color="error"
          sx={{
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 600,
          }}
          autoFocus
        >
          Leave Without Saving
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnsavedChangesDialog
